/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux"
import { getCatalogoTipoDocumento, getCatalogos, getCatalogosMembresia } from "../../services/catalogos"
import { appState, setAlert, setLoading } from "../../slices/appSlice"
import { useEffect, useState } from "react"
import DocumentComponent from "../generales/document"
import { ALERT_FAIL, ALERT_SUCCESS, CVE_ESTATUS_VAL_MEM, CVE_TIPODOC_ENTIDAD } from "../../app/constantes"
import { getEntidad, putCambioEstatusMembresia } from "../../services/entidad"
import { obtenerMisEmpresas } from "../../slices/entidadServicesSlice"

export default function ModalDocumentosAsociado({ modalData, setModalData }) {
    const dispatch = useDispatch()
    const appSt = useSelector(appState)
    const [documentosEntidad, setDocumentosEntidad] = useState(null)
    const [entidaData, setEntidadData] = useState(null)
    const [canValidate, setCanValidate] = useState(false)
    const [docUploaded, setUploaded] = useState(false)
    const [docsCat, setDocs] = useState(false)

    const closeModal = () => {
        setDocumentosEntidad(null)
        setEntidadData(null)
        setModalData({
            show: false,
            data: null
        })
    }

    const sendToValidate = async () => {
        dispatch(setLoading(true))
        try {
            const resp = await getCatalogosMembresia({
                ...appSt.serviceData,
                claveCatalogo: "memEstatusValidacion"
            })
            const revision = resp.find((item) => item.cveEstatusValidacionMembresia === CVE_ESTATUS_VAL_MEM.enRevision)

            await putCambioEstatusMembresia(
                {
                    ...appSt.serviceData,
                    idEntidad: modalData.data.id_entidad,
                },
                {
                    idEstatusValidacionMembresia: revision.idEstatusValidacionMembresia,
                }
            )
            dispatch(setAlert({
                show: true,
                message: "Documentos enviados a revisión",
                type: ALERT_SUCCESS
            }))
            dispatch(setLoading(false))
            dispatch(obtenerMisEmpresas({...appSt.serviceData, idUsuario: appSt.tokenInfo.sub}));
            closeModal()
        } catch (error) {
            console.error(error);
            dispatch(setLoading(false))
            dispatch(setAlert({
                show: true,
                message: "Error al enviar a validar documentos",
                type: ALERT_FAIL
            }))
        }
    }

    const getDocsMembresia = async () => {
        dispatch(setLoading(true))
        try {
            const entidadData = await getEntidad({
                ...appSt.serviceData,
                idEntidad: modalData.data.id_entidad
            })
            const regimenCat = await getCatalogos(appSt.serviceData.area, "regimenPersona", appSt.serviceData.token)
            const regimen = regimenCat.find((item) => item.idRegimenPersona === modalData.data.id_regimen_persona)
            let cve = ""
            if (regimen.cveRegimenPersona === "PERSONAMORAL") {
                cve = "ASOCIADOMORAL"
            } else {
                cve = "ASOCIADOFISICO"
            }
            const tipoDoc = await getCatalogoTipoDocumento(appSt.serviceData.area, appSt.serviceData.token, cve)
            const resp = await getCatalogos(appSt.serviceData.area, "documentoCemefi", appSt.serviceData.token, tipoDoc.idTipoDocumento)
            const array = []
            const uploaded = []
            resp.forEach(doc => {
                const docEntidad = entidadData.payload.cemDocumentoCrcEntidads.find(item => item.idDocumentoCemefi === doc.idDocumentoCemefi)
                if (docEntidad) {
                    uploaded.push(doc)
                    array.push({
                        ...docEntidad,
                        ...doc
                    })
                } else {
                    array.push(doc)
                }
            })
            console.log(entidaData)
            setUploaded(uploaded)
            setDocs(resp)
            setDocumentosEntidad(array)
            dispatch(setLoading(false))
            
        } catch (error) {
            console.error(error)
            dispatch(setLoading(false))
        }
    }

    useEffect(() => {
        if (modalData.data) {
            getDocsMembresia()
            setEntidadData({
                ...modalData.data,
                idEntidad: modalData.data.id_entidad
            })
        }
    }, [modalData.data])

    useEffect(() => {
        setCanValidate(docsCat.length !== docUploaded.length || 
            ((entidaData && entidaData.cveEstatusValidacionMembresia === CVE_ESTATUS_VAL_MEM.enRevision) || 
            (entidaData && entidaData.cveEstatusValidacionMembresia === CVE_ESTATUS_VAL_MEM.confirmada))
        )
    }, [entidaData, docsCat, docUploaded])

    
    return (<div className={modalData.show ? 'modal-wrapper active' : 'modal-wrapper'}>
        <div className="modal registro-documents">
            <div className="head">
                <h3>Documentos Asociado</h3>
                <button onClick={closeModal}>
                    x
                </button>
            </div>
            <div className="content">
                {entidaData && <div className="flex">
                    {entidaData.descEstatusValidacionMembresia && <div className="dato mr-1">
                        <label>Estatus</label>
                        <p>{entidaData.descEstatusValidacionMembresia}</p>
                    </div>}
                    {entidaData.motivoRechazoValidacion && <div className="dato">
                        <label>Motivo de Rechazo</label>
                        <p>{entidaData.motivoRechazoValidacion}</p>
                    </div>}
                </div>}
                
                <div className="documents-wrapper">
                    <div className="documents">
                        {entidaData && documentosEntidad && documentosEntidad.map((doc, index) => {
                            return (
                            <DocumentComponent 
                                canEdit={entidaData.cveEstatusValidacionMembresia !== CVE_ESTATUS_VAL_MEM.registrado && entidaData.cveEstatusValidacionMembresia !== CVE_ESTATUS_VAL_MEM.rechazada}
                                disabled={entidaData.cveEstatusValidacionMembresia !== CVE_ESTATUS_VAL_MEM.registrado && entidaData.cveEstatusValidacionMembresia !== CVE_ESTATUS_VAL_MEM.rechazada}
                                type={CVE_TIPODOC_ENTIDAD} 
                                empresaSeleccionada={entidaData} 
                                doc={doc} 
                                key={index} 
                                refresh={getDocsMembresia}
                            />)
                        })}
                    </div>
                </div>
            </div>
            <div className="actions">
                <button onClick={closeModal}>Cerrar</button>
                <button disabled={canValidate} onClick={sendToValidate}>Enviar a Validar</button>
            </div>
        </div>
    </div>)

}